import { entityLabelMatcher } from '../helpers/label-mapper';

const DefinitionMapper = (entityType, label, entityName) => {
  entityType = entityLabelMatcher(entityType, 'singular').toLocaleLowerCase();

  switch (label) {
    case 'revenue':
      return `Income generated from ${
        startsWithAVowel(entityType) ? 'an' : 'a'
      } ${entityType}'s activities.`;
    case 'expenses':
      return `Payments required to deliver ${
        startsWithAVowel(entityType) ? 'an' : 'a'
      } ${entityType}'s activities.`;
    case 'assets':
      return `A resource ${
        startsWithAVowel(entityType) ? 'an' : 'a'
      } ${entityType} controls that will provide a future benefit (for example, cash, land and buildings).`;
    case 'currentAssets':
      return 'An asset that is available for use, or is expected to be consumed in a short time, usually 12 months (for example cash).';
    case 'nonCurrentAssets':
      return 'An asset that is not a current asset (for example land and buildings)';
    case 'liabilities':
      return `${
        startsWithAVowel(entityType) ? 'An' : 'A'
      } ${entityType}'s obligations to make future payments (for example, payables, borrowings and employee entitlements).`;
    case 'currentLiabilities':
      return 'A liability that may be required to be settled in a short time, usually 12 months (for example payables due in 30 days).';
    case 'nonCurrentLiabilities':
      return 'A liability that is not a current liability (for example long term borrowings).';
    case 'ppEAdditions':
      return `PP&E additions are the additions to property, plant & equipment per the entity's 2019 financial statements`;
    case 'year2019StudentStaffRatioEftslFte':
      return `The student/staff ratio provides the number of students (at an EFTSL level) per staff member (at FTE level). Staff includes teaching and support staff and does not include staff employed by third party providers (that some universities may utilise to deliver courses)`;
    case 'shareholderReturns':
      return `Shareholder returns is made up of income tax equivalents and dividends. Dividends is a portion of a government owned corporation’s profits that it pays to its shareholders`;
    case 'entityCapacity':
      return `Per cent of total generation capacity of all state owned power stations`;
    case 'retailElectricity':
      return entityName === 'EQL'
        ? `Energy Queensland’s retail revenue is Ergon Energy Queensland’s consolidated amounts.`
        : '';
    case 'facilitiesPerEntity':
      return entityName === 'CS Energy'
        ? `CS Energy does not own Gladstone Power Station, however they are
      party to an agreement which allows them to trade any surplus output,
      after the daily requirements of the Boyne Aluminium Smelter have
      been met. Callide C is 50% owned by CS Energy.`
        : entityName === 'Stanwell'
          ? `Stanwell has decommissioned the Mackay Gas Turbine into retirement as at 1 April 2021`
          : '';
    default:
      return '';
  }
};

const startsWithAVowel = (word) => {
  return ['a', 'e', 'i', 'o', 'u'].includes(
    word.slice(0, 1).toLocaleLowerCase()
  );
};

export default DefinitionMapper;



// WEBPACK FOOTER //
// ./src/helpers/definition-mapper.js